export default __webpack_public_path__ + "static/slip-fall-912db74635d7dc8428d869e2e3470c72.jpg";